import { reactive } from '@vue/composition-api';
import type { Ref } from '@vue/composition-api';
import { useRequestGuard } from '@/composables/useRequestGuard';

interface InspectionConfirmModalState {
  showConfirmCompleteModal: boolean;
  showConfirmSkipModal: boolean;
}
interface UseInspectionSubmissionResult {
  isRequesting: Ref<boolean>;
  confirmModalState: InspectionConfirmModalState;
  submitInspection: (save: () => Promise<void>, errorMessage: string) => Promise<void>;
}

// 開始前点検・終了時点検の完了・スキップの確認モーダルの開閉状態を持ち、確定したらモーダルを閉じて保存を送る
export const useInspectionSubmission = (
  onError: (errorMessage: string) => void,
): UseInspectionSubmissionResult => {
  const { doRequest, isRequesting } = useRequestGuard(onError);
  const confirmModalState = reactive<InspectionConfirmModalState>({
    showConfirmCompleteModal: false,
    showConfirmSkipModal: false,
  });

  const submitInspection = async(save: () => Promise<void>, errorMessage: string): Promise<void> => {
    confirmModalState.showConfirmCompleteModal = false;
    confirmModalState.showConfirmSkipModal = false;
    await doRequest(save, errorMessage);
  };

  return { isRequesting, confirmModalState, submitInspection };
};
